export default "__VITE_ASSET__06553c29__"